module.exports = __webpack_public_path__ + "static/media/CarAdvise-LogoWhite.21c14e4d.svg";